import React from 'react';

import PropTypes from 'prop-types';

const StopErrorModal = ({ title, body, onClick }) => {
  return (
    <div className="stop-error-modal">
      <div className="inner">
        <button type="button" onClick={onClick}>&times;</button>
        <div className="text-center">
          <h2>{title}</h2>
          <p>{body}</p>
        </div>
      </div>
    </div>
  );
};

StopErrorModal.propTypes = {
  onClick: PropTypes.func.isRequired,
  title: PropTypes.string.isRequired,
  body: PropTypes.string.isRequired,
};

export default StopErrorModal;
